// extracted by mini-css-extract-plugin
export default {"productRow":"RenewableProductRow-productRow_RnYg8","renewables":"RenewableProductRow-renewables_pHz62","marginTopOnMobile":"RenewableProductRow-marginTopOnMobile__8KQ9"};